import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import ParentContractSetup from "./ParentContractSetup";

const ParentContractSetupPage = () => {
  return (
    <NavHeightAdjust>
      <ParentContractSetup />
    </NavHeightAdjust>
  );
};

export default ParentContractSetupPage;
